export const gqlMockServerURL = window.location.origin;

// Revert to legacy env variable usage
export const gqlServerURL = import.meta.env.VITE_APP_BASE_URL || "http://localhost:8080";

// Explicit GraphQL WebSocket URL (avoid Vite HMR ws). Example: wss://api.example.com/graphql
export const gqlWsURL =
  import.meta.env.VITE_GRAPHQL_WS_URL ||
  (gqlServerURL.replace('http', 'ws').replace('https', 'wss') + '/graphql');

export const baseURL = "";

export const websiteURL = "";

export const filePath = "";

export * from "./chart-config";

export const appEnv = import.meta.env.VITE_APP_ENV || "development";

export const sentryDSN = import.meta.env.VITE_SENTRY_DSN || "https://f6382ac757698f7c95785c8f12722d1c@o4509552315334656.ingest.us.sentry.io/4509552348168192";